import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PUBLIC_API } from '../http/http-context-tokens';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Public endpoints opt out of auth via publicApi(); attaching an expired
  // token (and pre-emptively 401-ing) would break their no-session flows.
  if (req.context.get(PUBLIC_API)) {
    return next(req);
  }

  const token = authService.token();
  if (!token) {
    return next(req);
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: 'Unauthorized',
          error: { error: 'token_expired' },
          url: req.url,
        }),
    );
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(authReq);
};
